import { Component, OnInit,PLATFORM_ID ,Inject,Output,EventEmitter } from '@angular/core';
import { CommonModule, DATE_PIPE_DEFAULT_OPTIONS,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { FacadeService } from '../../services/facade.service';

import { ProyectosService } from '../../services/proyectos.service';

import { AnalysisOptionsComponent } from '../../tools/analysis-options/analysis-options.component';
import {AnalysisServiceService } from '../../services/analysis-service/analysis-service.service';

import {BlockedModal2Component } from '../../tools/blocked-modal2/blocked-modal2.component';

@Component({
  selector: 'summary-free',
  standalone: true,
  imports: [ HttpClientModule,
    MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    AnalysisOptionsComponent,
    MatProgressBarModule],
  templateUrl: './summary-free.component.html',
  styleUrl: './summary-free.component.css'
})
export class SummaryFreeComponent implements OnInit{
  isScreenLarge: boolean = false;
  activeEyeIcon: HTMLImageElement | null = null;

  excludeDigits: boolean;

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject: boolean;

  loaderActiveSummary1: boolean;
  loaderActiveSummary2: boolean;
  loaderActiveSummary3: boolean;

  currentAnalysisMode: string;

  verifyLoaderActive2: boolean;

  isTooltipModalOpen = false;

  public project_data;

  cefr_short_words: boolean;
  lexical_short_words: boolean;
  short_words: boolean;

  @Output() menuItemSelected = new EventEmitter<string>(); 
  
  onSelectMenuItem(menuItem: string) { 
    this.menuItemSelected.emit(menuItem);
  }

  public summary={
    cefr:'C2',
    improvements:0,
    flesch_kincaid:null,
    cefr_too_short_error:null,
    lexical:null,
    lexical_too_short_error:null,
    academic: null,
    words_level:null,
    sentence_count:null,
    too_short_error:null,
    word_count:null,
    issues:null,
    sentences_30:null,
    sentences_20:null,
    words_4:null,
    words_3:null,
    words_2:null,
    words_12:null,
    words_10:null,
    metrics:{},
    sentences_data: []

  }

  public summary2:any ={
    improvements:0,
    flesch_kincaid:null,
    cefr_too_short_error:null,
    lexical:null,
    lexical_too_short_error:null,
    academic: null,
    words_level:null,
    sentence_count:null,
    too_short_error:null,
    word_count:null,
    issues:null,
    sentences_30:null,
    sentences_20:null,
    words_4:null,
    words_3:null,
    words_2:null,
    words_12:null,
    words_10:null,
    metrics:{},
    activar:{},
    llego_a_cefr:0,
    sentences_data: []
  }

  public summary3:any ={
    improvements:0,
    flesch_kincaid:null,
    cefr_too_short_error:null,
    lexical:null,
    lexical_too_short_error:null,
    academic: null,
    words_level:null,
    sentence_count:null,
    too_short_error:null,
    word_count:null,
    issues:null,
    sentences_30:null,
    sentences_20:null,
    words_4:null,
    words_3:null,
    words_2:null,
    words_12:null,
    words_10:null,
    metrics:{},
    activar:{},
    llego_a_cefr:0,
    sentences_data: []
  }

  isThereProject: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService:ProyectosService,
    private analysisService: AnalysisServiceService,
    private dialog: MatDialog
  ) { }

  openTooltipModal(event: MouseEvent): void {
    if (!this.isTooltipModalOpen) {
      this.isTooltipModalOpen = true;

      const dialogConfig = new MatDialogConfig();
      dialogConfig.position = {
        top: `${event.clientY - 30}px`,
        left: `${event.clientX + 20}px`
      };
      dialogConfig.width = '180px';
      dialogConfig.height = '96px'; 
      dialogConfig.hasBackdrop = false;
      dialogConfig.autoFocus = false;

      const dialogRef = this.dialog.open(BlockedModal2Component, dialogConfig);

      dialogRef.afterClosed().subscribe(() => {
        this.isTooltipModalOpen = false;
      });
    }
  }

  closeTooltipModal(): void {
    setTimeout(() => {
      this.dialog.closeAll();
    }, 1000);
  }

  openTooltipModalMobile(event: MouseEvent): void {
    if (!this.isTooltipModalOpen) {
      this.isTooltipModalOpen = true;

      const dialogConfig = new MatDialogConfig();
      dialogConfig.position = {
        top: `${event.clientY - 30}px`,
        left: `${event.clientX - 200}px`
      };
      dialogConfig.width = '180px';
      dialogConfig.height = '95px'; 
      dialogConfig.hasBackdrop = false;
      dialogConfig.autoFocus = false;

      const dialogRef = this.dialog.open(BlockedModal2Component, dialogConfig);

      dialogRef.afterClosed().subscribe(() => {
        this.isTooltipModalOpen = false;
      });

      
      setTimeout(() => { this.dialog.closeAll(); }, 2000);
    }
  }

  ngOnInit(): void {
    localStorage.setItem("actual", "summaryF")
    this.initSubscribe();

    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }

    this.analysisService.currentExcludeDigits.subscribe(value => this.excludeDigits = value);

    this.analysisService.currentAnalysisMode.subscribe(mode => {
      this.currentAnalysisMode = mode;
    });

    this.proyectoService.refreshTextBox$.subscribe(() => { 
      this.refreshComponent(); });
  
    if(sessionStorage.getItem("text_UID")){
      this.loaderActive = true;
    }
     this.proyectoService.loader$.subscribe(loader => {
      if(this.loaderActive2){
        this.loaderActive = false;
      }else{
        this.loaderActive = loader;
      }
    });

                this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;
      }
    });

         this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });

    this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });


     setInterval(() => {
      let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "summaryF" && sessionStorage.getItem("id_project") && !this.verifyLoaderActive2) {
      if(sessionStorage.getItem("summary") !== "-" && !this.loaderActive){
         this.loaderActive2 = false;
        this.loaderActive = false;
        this.loaderActiveFirstProject = false;
        this.loaderActiveSummary1 = false;
        this.proyectoService.updateDisableCreatingProject(false);
        this.proyectoService.updateloader(false);
        this.iniciarSummary();
      }
      if(sessionStorage.getItem("summaryP2") !== "-" && !this.loaderActive){
        this.loaderActiveSummary2 = false
        this.iniciarSummary2();
      }
      if(sessionStorage.getItem("summaryP3") !== "-" && !this.loaderActive){
        this.loaderActiveSummary3 = false
        this.iniciarSummary3();
      }
    }

  }, 20 * 1000); // 30 segundos
  }

  private refreshComponent() { 
    this.ngOnInit(); 
  }
  
  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }

  getBoxLineColorKincaid(value: number): string {
    if (value <= 6) {
      return 'box-line-green';
    } else if (value > 6 && value <= 13) {
      return 'box-line-yellow';
    } else if (value > 13) {
      return 'box-line-red';
    }
    return 'box-line';
  }

  getBoxLineColorVOCD(value: number): string {
    if (value <= 70) {
      return 'box-line-green';
    } else if (value > 70 && value <= 80) {
      return 'box-line-yellow';
    } else if (value > 80) {
      return 'box-line-red';
    }
    return 'box-line';
  }

  getBoxLineColorAcademic(value: number): string {
    if (value <= .5) {
      return 'box-line-green';
    } else if (value > .5 && value <= 3) {
      return 'box-line-yellow';
    } else if (value > 3) {
      return 'box-line-red';
    }
    return 'box-line';
  }

    mapToPercentage(value) {
  if (value <= 0) return 0;

  if (value <= 0.5) {
    // Primer tramo: 0 a 0.5 → 0% a 30%
    return (value / 0.5) * 30;
  }

  if (value <= 3) {
    // Segundo tramo: 0.5 a 3 → 30% a 80%
    return 30 + ((value - 0.5) / (3 - 0.5)) * 50;
  }

  else{
    // Segundo tramo: 0.5 a 3 → 30% a 80%
    return 100;
  }
 
}

  getBoxLineColorWordsLevel(value: number): string {
    if (value <=6) {
      return 'box-line-red';
    } else if (value > 6 && value <= 8) {
      return 'box-line-yellow';
    } else if (value > 8) {
      return 'box-line-green';
    }
    return 'box-line';
  }

  getTextLineFlesch(value: number): string {
    if (value <= 1) {
      return 'High Readability: 1st Grade Reading Level';
    } else if (value > 1 && value <= 2) {
      return 'High Readability: 1st Grade Reading Level';
    } else if (value > 2 && value <= 3) {
      return 'High Readability: 2nd Grade Reading Level';
    } else if (value > 3 && value <= 4) {
      return 'High Readability: 3rd Grade Reading Level';
    } else if (value > 4 && value <= 5) {
      return 'High Readability: 4th Grade Reading Level';
    } else if (value > 5 && value <= 6) {
      return 'High Readability: 5th Grade Reading Level';
    } else if (value > 6 && value <= 7) {
      return 'Moderate Readability: 6th Grade Reading Level';
    } else if (value > 7 && value <= 8) {
      return 'Moderate Readability: 7th Grade Reading Level';
    } else if (value > 8 && value <= 9) {
      return 'Moderate Readability: 8th Grade Reading Level';
    } else if (value > 9 && value <= 10) {
      return 'Moderate Readability: 9th Grade Reading Level';
    } else if (value > 10 && value <= 11) {
      return 'Moderate Readability: 10th Grade Reading Level';
    } else if (value > 11 && value <= 12) {
      return 'Moderate Readability: 11th Grade Reading Level';
    } else if (value > 12 && value <= 13) {
      return 'Moderate Readability: 12th Grade Reading Level';
    } else if (value > 13 && value <= 16) {
      return 'Low Readability: University Student Reading Level';
    } else if (value > 16 && value <= 18) {
      return 'Very Low Readability: University Graduate Reading Level';
    } else if (value > 18) {
      return 'Very Low Readability: University Graduate Reading Level';
    }
    
    return '';
  }

  getTextLineLexical(value: number): string {
    if (value <= 65) {
      return 'Low Vocabulary Diversity';
    } else if (value > 65 && value <= 80) {
      return 'Medium Vocabulary Diversity';
    } else if (value > 80) {
      return 'High Vocabulary Diversity';
    }
    return '';
  }

  getTextLineAcademic(value: number): string {
    if (value <= .5) {
      return 'Low % of AWL Words (Tokens)';
    } else if (value > .5 && value <= 3) {
      return 'Medium % of AWL Words (Tokens)';
    } else if (value > 3) {
      return 'High % of AWL Words (Tokens)';
    }
    return 'box-line';
  }

  getTextLineWordsLevel(value: number): string {
    if ( value <= 6) {
      return 'Low % of B1 Level Words (Tokens)';
    } else if (value > 6 && value <= 8) {
      return 'Medium % of B1 Level Words (Tokens)';
    } else if (value > 8) {
      return 'High % of B1 Level Words (Tokens)';
    }
    return 'box-line';
  }

  isMatchingLevel(level: string): boolean {
    return level === this.summary.cefr;
  }


  //Para el cambio de color de los ojos
  toggleEyeIcon_Sentence(event: Event, array_data = null): void {
    const element = event.target as HTMLImageElement;
    // Si hay un icono activo y no es el mismo que se hizo clic, restablecer su imagen
    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
    }

    // Cambiar la imagen del icono actual
    if (element.src.includes('eye-icon.svg')) {
      //Prende 
      this.proyectoService.realizarMarcadoSentencesStatis(array_data, "sentence", this.http,this.excludeDigits)
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element; // Establecer el icono actual como activo
    } else {
      //Apaga
      this.proyectoService.undoMarcadoMultiple(this.http)
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null; // No hay icono activo
    }
  }

    toggleEyeIcon_Words(event: Event, array_data = null): void {
    const element = event.target as HTMLImageElement;
    // Si hay un icono activo y no es el mismo que se hizo clic, restablecer su imagen
    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
    }

    // Cambiar la imagen del icono actual
    if (element.src.includes('eye-icon.svg')) {
      //Prende 
      this.proyectoService.realizarMarcadoTokensWordsSummary(array_data, "k1", this.http)
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element; // Establecer el icono actual como activo
    } else {
      //Apaga
      this.proyectoService.undoMarcadoMultiple(this.http)
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null; // No hay icono activo
    }
  }
 



  getFleschKincaidDisplay(): string {
  const idProject = sessionStorage.getItem("id_project");

  // Si no hay id_project, mostramos "--"
  if (!idProject) return "--";

  // Si existe summary2 y tiene un valor null, mostramos "0.00"
  if (this.summary2 && this.summary2.flesch_kincaid == null) return "0.00";

  // Si tiene valor definido, lo mostramos tal cual
  return this.summary2?.flesch_kincaid ?? "--";
}

getLexicalDisplay(): string {
  const idProject = sessionStorage.getItem("id_project");

  // Si no hay id_project, mostramos "--"
  if (!idProject) return "--";

  // Si existe summary2 y tiene un valor null, mostramos "0.00"
  if (this.summary2 && this.summary2.lexical == null) return "0.00";

  // Si tiene valor definido, lo mostramos tal cual
  return this.summary2?.lexical ?? "--";
}

getAcademicDisplay(): string {
  const idProject = sessionStorage.getItem("id_project");

  // Si no hay id_project, mostramos "--"
  if (!idProject) return "--";

  // Si existe summary2 y tiene un valor null, mostramos "0.00"
  if (this.summary3 && this.summary3.academic == null) return "0.00";

  // Si tiene valor definido, lo mostramos tal cual
  return this.summary3?.academic ?? "--";
}

getWordsLevelDisplay(): string {
  const idProject = sessionStorage.getItem("id_project");

  // Si no hay id_project, mostramos "--"
  if (!idProject) return "--";

  // Si existe summary2 y tiene un valor null, mostramos "0.00"
  if (this.summary3 && this.summary3.words_level == null) return "0.00";

  // Si tiene valor definido, lo mostramos tal cual
  return this.summary3?.words_level ?? "--";
}

status: any;

  async iniciarSummary() {
let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "summaryF") {
      // -------------------------------------------------
      // -------------------------------------------------
      // -----------------ENDPOINT 1----------------------
      // -------------------------------------------------
      // -------------------------------------------------
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("summary");
      if (memoryStorage) {
        if(memoryStorage !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          this.summary = JSON.parse(memoryStorage);
          this.summary.cefr = 'C2'

         
        } catch (error) {
          console.log("Ocurrió un error");

          if (error instanceof TypeError) {
            console.error("TypeError: problema con el tipo de datos o red");
            console.error(error.message);
          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor");
            console.error(error.message);
            sessionStorage.removeItem('summary');
          } else {
            console.error("Otro tipo de error:");
            console.error(error);
            sessionStorage.removeItem('summary');
          }

        } finally {
          this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.loaderActiveSummary1 = false;
          this.proyectoService.updateDisableCreatingProject(false);
          this.proyectoService.updateloader(false);
        }
      }
      } else {
        sessionStorage.setItem("summary", "-");
        // Si no hay datos en sessionStorage, hacer la petición normalmente
        await new Promise(resolve => setTimeout(resolve, 10));

        try {
          let textUID = sessionStorage.getItem('text_UID');
          let respuesta = await this.fachada.getSummaryOfProject(
            this.http,
            textUID,
            localStorage.getItem("text-inspector-django-token")
          );

          this.summary = respuesta;

          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("summary", JSON.stringify(this.summary));
          this.summary.cefr = 'C2'


          if (sessionStorage.getItem("text_UID")) {
              this.isThereProject = true;
            }
            else{
              this.isThereProject = false;
            }


          this.status = 200
        } catch (error) {
          if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (summary)");
            sessionStorage.removeItem('summary');
            this.status = 0

          }
          if (error instanceof TypeError) {
            console.error("TypeError: problema con el tipo de datos o red");
            console.error(error.message);
          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor");
            console.error(error.message);
            sessionStorage.removeItem('summary');
          } else {
            console.error("Otro tipo de error:");
            console.error(error);
            sessionStorage.removeItem('summary');
          }

          this.status = error?.status;

        } finally {

          if (this.status === 0) {
            this.loaderActive2 = true;
            this.loaderActive = true;
            this.loaderActiveFirstProject = true;
            this.loaderActiveSummary1 = true;
            this.proyectoService.updateDisableCreatingProject(true);
            this.proyectoService.updateloader(true);
            setTimeout(() => {
              this.iniciarSummary();
            }, 100);
          } else {
            this.loaderActive2 = false;
            this.loaderActive = false;
            this.loaderActiveFirstProject = false;
            this.loaderActiveSummary1 = false;
            this.proyectoService.updateDisableCreatingProject(false);
            this.proyectoService.updateloader(false);
             setTimeout(() => {
              this.iniciarSummary();
            }, 100);
          }
        }
      }
      }else{
      console.log(`summary no es la pantalla actual así que bloqueamos peticiones`)
    }
  }

  status2: any;
  async iniciarSummary2() {
    // -------------------------------------------------
    // -------------------------------------------------
    // -----------------ENDPOINT 2----------------------
    // -------------------------------------------------
    // -------------------------------------------------

     let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "summaryF") {
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage2 = sessionStorage.getItem("summaryP2");
      if (memoryStorage2) {
        if(memoryStorage2 !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          this.summary2 = JSON.parse(memoryStorage2);

          // Asignar valores derivados como antes
           setTimeout(() => {
            this.getFleschKincaidDisplay()
            this.getLexicalDisplay()
          }, 100);
          

        } catch (error) {
          console.log("Ocurrió un error (summary2)");
          if (error instanceof TypeError) {
            console.error("TypeError: problema con el tipo de datos o red (summary2)");
            console.error(error.message);
          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor (summary2)");
            console.error(error.message);
            sessionStorage.removeItem('summaryP2');
          } else {
            console.error("Otro tipo de error: (summary2)");
            console.error(error);
            sessionStorage.removeItem('summaryP2');
          }
          // Guardamos el status del error si viene disponible

        } finally {
          this.loaderActiveSummary2 = false;
        }
      }
      } else {
        sessionStorage.setItem("summaryP2", "-");
        // Si no hay datos en sessionStorage, hacer la petición normalmente
        await new Promise(resolve => setTimeout(resolve, 10));

        try {
          let textUID = sessionStorage.getItem('text_UID');
          let respuesta2 = await this.fachada.getSummary2OfProject(
            this.http,
            textUID,
            localStorage.getItem("text-inspector-django-token")
          );

          this.summary2 = respuesta2;

          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("summaryP2", JSON.stringify(this.summary2));

         setTimeout(() => {
            this.getFleschKincaidDisplay()
            this.getLexicalDisplay()
          }, 100);

          if (sessionStorage.getItem("text_UID")) {
              this.isThereProject = true;
            }
            else{
              this.isThereProject = false;
            }

          this.status2 = 200;

        } catch (error) {
          console.log("Ocurrió un error (summary2)");
          if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (summary2)");
            sessionStorage.removeItem('summaryP2');
            this.status2 = 0
          }
          if (error instanceof TypeError) {
            console.error("TypeError: problema con el tipo de datos o red (summary2)");
            console.error(error.message);
          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor (summary2)");
            console.error(error.message);
            sessionStorage.removeItem('summaryP2');
          } else {
            console.error("Otro tipo de error:");
            console.error(error);
            sessionStorage.removeItem('summaryP2');
          }

          this.status2 = error?.status;

        } finally {
          if (this.status2 === 0) {
            this.loaderActiveSummary2 = true
            setTimeout(() => {
              this.iniciarSummary2();
            }, 100);
          } else {
            this.loaderActiveSummary2 = false
             setTimeout(() => {
              this.iniciarSummary2();
            }, 100);
          }
        }
      }
       }else{
      console.log(`summary no es la pantalla actual así que bloqueamos peticiones`)
    }
  }

  status3: any;
  async iniciarSummary3() {
     let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "summaryF") {
    // -------------------------------------------------
    // -------------------------------------------------
    // -----------------ENDPOINT 3----------------------
    // -------------------------------------------------
    // -------------------------------------------------
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage3 = sessionStorage.getItem("summaryP3");
      if (memoryStorage3) {
        if(memoryStorage3 !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          this.summary3 = JSON.parse(memoryStorage3);

          setTimeout(() => {
            this.getAcademicDisplay()
            this.getWordsLevelDisplay()
          }, 100);


        } catch (error) {
          console.log("Ocurrió un error (summary3)");

          if (error instanceof TypeError) {
            console.error("TypeError: problema con el tipo de datos o red (summary3)");
            console.error(error.message);
          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor (summary3)");
            console.error(error.message);
            sessionStorage.removeItem('summaryP3');
          } else {
            console.error("Otro tipo de error: (summary3)");
            console.error(error);
            sessionStorage.removeItem('summaryP3');
          }

        } finally {
          this.loaderActiveSummary3 = false;
        }
      }
      } else {
        

        sessionStorage.setItem("summaryP3", "-");
        // Si no hay datos en sessionStorage, hacer la petición normalmente
        await new Promise(resolve => setTimeout(resolve, 10));

        try {
          let textUID = sessionStorage.getItem('text_UID');


          let respuesta3 = await this.fachada.getSummary3OfProject(
            this.http,
            textUID,
            localStorage.getItem("text-inspector-django-token")
          );

          this.summary3 = respuesta3;

          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("summaryP3", JSON.stringify(this.summary3));

         setTimeout(() => {
            this.getAcademicDisplay()
            this.getWordsLevelDisplay()
          }, 100);


          if (sessionStorage.getItem("text_UID")) {
              this.isThereProject = true;
            }
            else{
              this.isThereProject = false;
            }


          this.status3 = 200

        } catch (error) {
          console.log("Ocurrió un error (summary3)");

          if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (summary3)");
            sessionStorage.removeItem('summaryP3');

          }
          if (error instanceof TypeError) {
            console.error("TypeError: problema con el tipo de datos o red (summary3)");
            console.error(error.message);
          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor (summary3)");
            console.error(error.message);
            sessionStorage.removeItem('summaryP3');
          } else {
            console.error("Otro tipo de error: (summary3)");
            console.error(error);
            sessionStorage.removeItem('summaryP3');
          }

          this.status3 = error?.status;

        } finally {
          if (this.status3 === 0) {
            this.loaderActiveSummary3 = true;
            setTimeout(() => {
              this.iniciarSummary3();
            }, 100);
          }
          else {
            this.loaderActiveSummary3 = false;
             setTimeout(() => {
              this.iniciarSummary3();
            }, 100);
            
          }
          
        }
      
      }
      }else{
      console.log(`summary no es la pantalla actual así que bloqueamos peticiones`)
    }
  }

  private proyectoSub;

  initSubscribe() {
    if (!this.proyectoSub || this.proyectoSub.closed) {
      if (sessionStorage.getItem("text_UID")) {
         this.isThereProject = true;
      }
      else{
        this.isThereProject = false;
      }
      //Subscribimos al servicio para escuchar los datos
      this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject }) => {
        if (!firstProject) {
          this.loaderActive = false;
          if (sessionStorage.getItem("text_UID")) {
            if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
            this.loaderActiveSummary1 = true;
            this.loaderActiveSummary2 = true;
            this.loaderActiveSummary3 = true;
          } else {
            this.loaderActive2 = false;
          }
        }
        if (firstProject) {
          this.loaderActive = false;
          if (sessionStorage.getItem("text_UID")) {
            this.loaderActiveFirstProject = true;
            this.loaderActiveSummary1 = true;
            this.loaderActiveSummary2 = true;
            this.loaderActiveSummary3 = true;
          } else {
            this.loaderActiveFirstProject = false;
          }
        }
        console.log("Update de data --Reporta: Summary--")
        this.project_data = proyecto;

        if(sessionStorage.getItem("id_project")){
           this.iniciarSummary();
            this.iniciarSummary2();
            this.iniciarSummary3();
            ("Estoy entrando aqui")
        }
      });
    }
  }












    reiniciarSummary(): void {
    this.summary.cefr = null,
      this.summary.improvements = 0,
      this.summary.flesch_kincaid = null,
      this.summary.cefr_too_short_error = null,
      this.summary.lexical = null,
      this.summary.lexical_too_short_error = null,
      this.summary.academic = null,
      this.summary.words_level = null,
      this.summary.sentence_count = null,
      this.summary.too_short_error = null,
      this.summary.word_count = null,
      this.summary.issues = null,
      this.summary.sentences_30 = null,
      this.summary.sentences_20 = null,
      this.summary.words_4 = null,
      this.summary.words_3 = null,
      this.summary.words_2 = null,
      this.summary.words_12 = null,
      this.summary.words_10 = null,
      this.summary.metrics = {}


    this.summary2.cefr = null,
      this.summary2.improvements = 0,
      this.summary2.flesch_kincaid = null,
      this.summary2.cefr_too_short_error = null,
      this.summary2.lexical = null,
      this.summary2.lexical_too_short_error = null,
      this.summary2.academic = null,
      this.summary2.words_level = null,
      this.summary2.sentence_count = null,
      this.summary2.too_short_error = null,
      this.summary2.word_count = null,
      this.summary2.issues = null,
      this.summary2.sentences_30 = null,
      this.summary2.sentences_20 = null,
      this.summary2.words_4 = null,
      this.summary2.words_3 = null,
      this.summary2.words_2 = null,
      this.summary2.words_12 = null,
      this.summary2.words_10 = null,
      this.summary2.metrics = {}


    this.summary3.cefr = null,
      this.summary3.improvements = 0,
      this.summary3.flesch_kincaid = null,
      this.summary3.cefr_too_short_error = null,
      this.summary3.lexical = null,
      this.summary3.lexical_too_short_error = null,
      this.summary3.academic = null,
      this.summary3.words_level = null,
      this.summary3.sentence_count = null,
      this.summary3.too_short_error = null,
      this.summary3.word_count = null,
      this.summary3.issues = null,
      this.summary3.sentences_30 = null,
      this.summary3.sentences_20 = null,
      this.summary3.words_4 = null,
      this.summary3.words_3 = null,
      this.summary3.words_2 = null,
      this.summary3.words_12 = null,
      this.summary3.words_10 = null,
      this.summary3.metrics = {}
  }
}
